<template>
  <wrapper-page page-title="Vessels Status">
    <vessels-status-kpis v-if="!loadingKpis" :vesselsStatus="vesselsStatus" />
    <div class="mt-3">
      <div
        class="card-header bg-white d-flex justify-content-between align-items-center py-3 cursor-pointer"
        :class="isMetricesExpanded ? '' : ' mb-4'"
        style="cursor: pointer"
        @click="isMetricesExpanded = !isMetricesExpanded"
      >
        <h6 class="m-0 font-weight-bold text-primary">Vessels Metrics</h6>
        <button
          type="button"
          class="btn btn-sm btn-link text-decoration-none p-0"
        >
          <i
            class="fas"
            :class="isMetricesExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
          ></i>
        </button>
      </div>
      <div v-if="isMetricesExpanded" class="d-flex gap-3">
        <chart-card
          v-if="commercialGT?.length"
          :value="commercialGT"
          label="Combined GT – Commercial Yachts"
          size="col-xl-4 col-lg-6 col-md-6"
          :showChartTypes="['pie', 'bar']"
        ></chart-card>
        <chart-card
          v-if="commercialCount?.length"
          :value="commercialCount"
          label="Combined – Commercial Yachts"
          size="col-xl-4 col-lg-6 col-md-6"
          :showChartTypes="['pie', 'bar']"
        ></chart-card>
      </div>
    </div>
    <VesselMetricsChart />
  </wrapper-page>
</template>

<script>
import { getVesselsWeightSummary, getVesselsStatus } from "@/apis/kpis";
import WrapperPage from "../../components/layout/WrapperPage.vue";
import VesselsStatusKpis from "../../components/vessels/kpis/VesselsStatusKpis.vue";
import ChartCard from "@/components/ui/ChartCard.vue";
import VesselMetricsChart from "@/components/vessels/kpis/CommercialHistoryChart.vue";

export default {
  name: "VesselsDashboard",
  components: {
    ChartCard,
    WrapperPage,
    VesselsStatusKpis,
    VesselMetricsChart,
  },
  data() {
    return {
      loadingWeightSummary: true,
      loadingKpis: true,
      weightSummary: null,
      vesselsStatus: [],
      isMetricesExpanded: false,
    };
  },
  methods: {
    async fetchVesselWeightSummary() {
      this.loadingWeightSummary = true;
      try {
        const response = await getVesselsWeightSummary();
        this.weightSummary = response.data?.[0];
      } finally {
        this.loadingWeightSummary = false;
      }
    },
    async fetchVesselsStatuses() {
      this.loadingKpis = true;
      try {
        const response = await getVesselsStatus();
        this.vesselsStatus = response.data;
      } finally {
        this.loadingKpis = false;
      }
    },
  },
  computed: {
    commercialGT() {
      const data = [];

      if (this.weightSummary?.summ_commercial_gt_in_service)
        data.push({
          type: "In Service",
          number: this.weightSummary?.summ_commercial_gt_in_service,
        });

      if (this.weightSummary?.summ_commercial_gt_in_progress)
        data.push({
          type: "In Progress",
          number: this.weightSummary?.summ_commercial_gt_in_progress,
        });

      if (this.weightSummary?.summ_commercial_gt_under_construction)
        data.push({
          type: "Under Construction",
          number: this.weightSummary?.summ_commercial_gt_under_construction,
        });

      return data;
    },
    commercialCount() {
      const data = [];

      if (this.weightSummary?.count_commercial_vessels_in_service)
        data.push({
          type: "In Service",
          number: this.weightSummary?.count_commercial_vessels_in_service,
        });

      if (this.weightSummary?.count_commercial_vessels_in_progress)
        data.push({
          type: "In Progress",
          number: this.weightSummary?.count_commercial_vessels_in_progress,
        });

      if (this.weightSummary?.count_commercial_vessels_under_construction)
        data.push({
          type: "Under Construction",
          number:
            this.weightSummary?.count_commercial_vessels_under_construction,
        });

      return data;
    },
  },
  mounted() {
    this.fetchVesselWeightSummary();
    this.fetchVesselsStatuses();
  },
};
</script>
